var _ellipse, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError429HeaderImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 330,
    viewBox: "0 0 664 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 376,
    cy: 121.5,
    rx: 121,
    ry: 121.5,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.45 324.408L321.64 176.825L173.243 314.73L93.5692 236.54L0 328.367H187.138L187.029 328.259H484.595L484.248 327.937H663.992L570.423 236.11L480.45 324.408Z",
    fill: "#191B74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.405 328.161L323.42 224.094L212.326 327.332L154.323 265L95 328.75H210.8L210.517 329.014H436.323L436.039 328.75H552.64L493.75 265L435.405 328.161Z",
    fill: "#161762"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.843 50.0002C413.41 50.0002 420.53 56.1917 421.974 64.344C423.419 56.1918 430.539 50.0004 439.106 50.0004C448.007 50.0004 455.346 56.6837 456.38 65.3057C458.474 64.4134 460.778 63.9196 463.197 63.9196C472.806 63.9196 480.596 71.7094 480.596 81.3186C480.596 83.686 480.123 85.943 479.267 88.0002H609C614.523 88.0002 619 92.4774 619 98.0002C619 103.523 614.523 108 609 108H352C346.477 108 342 103.523 342 98.0002C342 92.4774 346.477 88.0002 352 88.0002H358.167C359.344 79.5362 366.611 73.0206 375.399 73.0206C377.524 73.0206 379.56 73.4016 381.443 74.0989C382.993 50.0002 395.827 50.0002 404.843 50.0002Z",
    fill: "#A4A6E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.843 103C198.41 103 205.53 109.192 206.974 117.344C208.419 109.192 215.539 103 224.106 103C233.007 103 240.346 109.684 241.38 118.305C243.474 117.413 245.778 116.919 248.197 116.919C257.806 116.919 265.596 124.709 265.596 134.318C265.596 136.308 265.262 138.22 264.647 140H344.5C350.299 140 355 144.701 355 150.5C355 156.299 350.299 161 344.5 161H147.5C141.701 161 137 156.299 137 150.5C137 146.242 139.534 142.576 143.177 140.929C144.385 132.499 151.636 126.02 160.399 126.02C162.189 126.02 163.916 126.291 165.541 126.793C163.43 103 180.865 103 189.843 103Z",
    fill: "#A4A6E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.877 161C449.346 161 453.06 164.231 453.811 168.484C454.562 164.231 458.276 161 462.745 161C467.387 161 471.214 164.485 471.753 168.981C472.845 168.516 474.046 168.259 475.307 168.259C480.318 168.259 484.38 172.321 484.38 177.332C484.38 177.557 484.372 177.78 484.356 178H524.5C528.09 178 531 180.91 531 184.5C531 188.09 528.09 191 524.5 191H395.5C391.91 191 389 188.09 389 184.5C389 180.91 391.91 178 395.5 178H420.483C420.877 173.353 424.774 169.704 429.523 169.704C430.441 169.704 431.327 169.84 432.162 170.094C432.85 161 440.656 161 444.877 161Z",
    fill: "#A4A6E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError429HeaderImage);
export default __webpack_public_path__ + "static/media/error-429-header-image.c5f8db034439076c38837d37a6470a06.svg";
export { ForwardRef as ReactComponent };